"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lodash = _interopRequireDefault(require("lodash.isempty"));
var _warn = _interopRequireDefault(require("./utils/warn"));
var browser = _interopRequireWildcard(require("./utils/browser"));
var _VideoPlayerRegistry = _interopRequireDefault(require("./VideoPlayerRegistry"));
var _theo = _interopRequireDefault(require("./players/theo"));
var _jw = _interopRequireDefault(require("./players/jw"));
var _package = require("../package.json");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Module that provides the `VideoPlayer` class.
 *
 * @module VideoPlayer
 */
// The package information is populated during the npm publish process
var packageName = typeof PACKAGE_NAME !== 'undefined' ? PACKAGE_NAME : 'hudl-video-playback';
var packageVersion = typeof PACKAGE_VERSION !== 'undefined' ? PACKAGE_VERSION : _package.version;

// Player config string values
var JW_PLAYER_CONFIG = 'jw';
var THEO_PLAYER_CONFIG = 'theo';

/**
 * Video playback class that provides a consistent API to various underlying
 * third party video players, as well as logging capabilities for the various
 * playback events that can occur.
 *
 * @example
 * import { VideoPlayer } from 'hudl-video-playback';
 *
 * window.player = new VideoPlayer({
 *   'domNode': document.getElementById('container'),
 *   'playables': [{src: 'http://path/to/video.m3u8'}],
 *   'player': 'theo',
 *   'loggerCallback': function(data) {},
 *   'timeUpdateInterval': 50
 * });
 */
var VideoPlayer = exports["default"] = /*#__PURE__*/function () {
  /**
   * Creates an instance of `VideoPlayer`.
   * @param {PlayerConfig} config - The player configuration object
   */
  function VideoPlayer(config) {
    _classCallCheck(this, VideoPlayer);
    config.log = process.env.NODE_ENV !== 'production' && config.log ? config.log : true;
    config.packageName = packageName;
    config.packageVersion = packageVersion;

    /** @ignore */
    this._playerConfig = config;
    /** @ignore */
    this._isPlayerRecovered = false;
    /** @ignore */
    this.recoveryCurrentTime = 0;
    /** @ignore */
    this._playerEventListenerMap = {};
    /** @ignore */
    this.internalPlayer = {};
    if (!config.id) {
      config.id = Math.floor(Math.random() * +new Date()).toString(16).substr(2);
    }
    this.id = config.id;
    if (this._playerConfig.playables && this._playerConfig.playables.length < 1) {
      delete this._playerConfig.playables;
    }
    this._constructPlayer();
    return this;
  }
  return _createClass(VideoPlayer, [{
    key: "_canCallMethodOnPlayer",
    value:
    /**
     * Checks whether the internal player is initialized and logs a warning to the
     * console if that is not the case.
     * @private
     */
    function _canCallMethodOnPlayer(methodUsed) {
      var playablesRequired = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var isInitialized = !(0, _lodash["default"])(this.internalPlayer);
      var canCallMethod = isInitialized;
      if (isInitialized && playablesRequired) {
        canCallMethod = !!this.internalPlayer.src;
      }
      if (!canCallMethod) {
        (0, _warn["default"])("Cannot call method ".concat(methodUsed, "() on a player that has no video source (src) set"));
      }
      return canCallMethod;
    }

    /**
     * Creates an instance of the 3rd party player that is used internally
     * @private
     */
  }, {
    key: "_constructPlayer",
    value: function _constructPlayer(forcePlayerType) {
      var config = this._playerConfig;
      var Player = null;
      if (!forcePlayerType && browser.isSafari() && parseFloat(browser.getVersion()) < 8.0) {
        // Safari v7 or earlier requires JW
        if (config.player && config.player !== JW_PLAYER_CONFIG) {
          config.player = JW_PLAYER_CONFIG;
          (0, _warn["default"])('JW Player is recommended for Safari versions below 8.0. Using JW Player instead.');
        }
        Player = _jw["default"];
      } else if (config.player) {
        switch (config.player) {
          case JW_PLAYER_CONFIG:
            Player = _jw["default"];
            break;
          case THEO_PLAYER_CONFIG:
            Player = _theo["default"];
            break;
          default:
            (0, _warn["default"])("Invalid player configuration value: ".concat(config.player, ", Use one of the following: ").concat(JW_PLAYER_CONFIG, ", ").concat(THEO_PLAYER_CONFIG));
            // Default to using THEOplayer
            Player = _theo["default"];
        }
      } else {
        // Default to using THEOplayer
        Player = _theo["default"];
      }

      // Store what the alternate player would be in case of recovery
      config.alternate = config.player === THEO_PLAYER_CONFIG ? JW_PLAYER_CONFIG : THEO_PLAYER_CONFIG;
      if (this.recoveryCurrentTime > 0) {
        config.startCurrentTime = this.recoveryCurrentTime;
      }
      this.internalPlayer = new Player(config);
      (0, _VideoPlayerRegistry["default"])(this.internalPlayer);
      return this;
    }

    /**
     * Restores the event listeners to the player in case of recovery
     * @private
     */
  }, {
    key: "_restoreEventListeners",
    value: function _restoreEventListeners() {
      var eventListenerMap = this._playerEventListenerMap;
      var ev = null;
      for (ev in eventListenerMap) {
        if (eventListenerMap.hasOwnProperty(ev)) {
          this.addEventListener(ev, eventListenerMap[ev]);
        }
      }
    }

    /**
     * Adds an event listener for a particular event.
     * @param {string} event - The event to listen to
     * @param {function} callback - The callback to be run when the event occurs
     */
  }, {
    key: "addEventListener",
    value: function addEventListener(event, callback) {
      if (!this._canCallMethodOnPlayer('addEventListener')) {
        return;
      }
      this._playerEventListenerMap[event] = callback;
      this.internalPlayer.on(event, callback);
    }

    /**
     * Removes an event listener for a particular event.
     * @param {string} event - The event being listened to
     * @param {function} callback - The callback to be removed
     */
  }, {
    key: "removeEventListener",
    value: function removeEventListener(event, callback) {
      if (!this._canCallMethodOnPlayer('removeEventListener')) {
        return;
      }
      delete this._playerEventListenerMap[event];
      this.internalPlayer.off(event, callback);
    }
  }, {
    key: "updateCdnInformation",
    value: function updateCdnInformation(src) {
      this.internalPlayer.getCdnInformation(src);
    }

    /**
     * Play the player's video source.
     */
  }, {
    key: "play",
    value: function play() {
      if (!this._canCallMethodOnPlayer('play', true)) {
        return;
      }
      this.internalPlayer.play();
    }

    /**
     * Pause the player's video source.
     */
  }, {
    key: "pause",
    value: function pause() {
      if (!this._canCallMethodOnPlayer('pause', true)) {
        return;
      }
      this.internalPlayer.pause();
    }

    /**
     * Re-creates the player using the other 3rd party player available.
     */
  }, {
    key: "recover",
    value: function recover() {
      if (this._isPlayerRecovered) {
        (0, _warn["default"])('Player already recovered, no alternate players available');
        return;
      }
      var config = this._playerConfig;
      config.player = config.alternate;

      // Store playback time before failure
      this.recoveryCurrentTime = this.currentTime;

      // Cleanup the existing player
      this.internalPlayer.destroy();

      // Instantiate the alternate player forcing its use
      this._constructPlayer(true);
      this._isPlayerRecovered = true;

      // Restore any existing event listeners;
      this._restoreEventListeners();
    }

    /**
     * Returns the video aspectRatio if required information is available.
     * @type {number}
     */
  }, {
    key: "aspectRatio",
    get: function get() {
      return this.internalPlayer.aspectRatio;
    }

    /**
     * Returns whether the player should automatically advance to the next clip.
     * @type {boolean}
     */
  }, {
    key: "autoAdvance",
    get: function get() {
      return this.internalPlayer.autoAdvance;
    }

    /**
     * Sets whether the player should automatically advance to the next clip.
     */,
    set: function set(a) {
      this.internalPlayer.autoAdvance = a;
    }

    /**
     * Returns whether the video is configured to start playing automatically.
     * @type {boolean}
     */
  }, {
    key: "autoplay",
    get: function get() {
      return this.internalPlayer.autoplay;
    }

    /**
     * Sets whether the video should start playing automatically on load.
     * @type {boolean}
     */,
    set: function set(a) {
      this.internalPlayer.autoplay = a;
    }

    /**
     * Returns whether the playlist clip is configured to start playing automatically.
     * @type {boolean}
     */
  }, {
    key: "autoPlayClips",
    get: function get() {
      return this.internalPlayer.autoPlayClips;
    }

    /**
     * Sets whether the playlist clip should start playing automatically on load.
     * @type {boolean}
     */,
    set: function set(a) {
      this.internalPlayer.autoPlayClips = a;
    }

    /**
     * Checks if the video player supports slow rewind.
     * @type {boolean}
     */
  }, {
    key: "canPlaySlowBackward",
    get: function get() {
      return this.internalPlayer.canPlaySlowBackward;
    }

    /**
     * Checks if the video player supports fast rewind.
     * @type {boolean}
     */
  }, {
    key: "canPlayFastBackward",
    get: function get() {
      return this.internalPlayer.canPlayFastBackward;
    }

    /**
     * Checks if the video player supports slow forward playback.
     * @type {boolean}
     */
  }, {
    key: "canPlaySlowForward",
    get: function get() {
      return this.internalPlayer.canPlaySlowForward;
    }

    /**
     * Checks if the video player supports fast forward playback.
     * @type {boolean}
     */
  }, {
    key: "canPlayFastForward",
    get: function get() {
      return this.internalPlayer.canPlayFastForward;
    }

    /**
     * Get the player specific buffer information.
     * @type {object[]|number}
     */
  }, {
    key: "buffered",
    get: function get() {
      return this.internalPlayer.buffered;
    }

    /**
     * Get the current frame number of the active video quality.
     * @type {number}
     */
  }, {
    key: "currentFrame",
    get: function get() {
      return this.internalPlayer.currentFrame;
    }

    /**
     * Sets the current frame number, the player seeks to the given frame number
     * if `frameAccurateSeekEnabled` is true in the player configuration.
     * @type {number}
     */,
    set: function set(f) {
      this.internalPlayer.currentFrame = f;
    }

    /**
     * Returns the currently playing video quality object.
     * @type {Quality}
     */
  }, {
    key: "currentQuality",
    get: function get() {
      return this.internalPlayer.currentQuality;
    }

    /**
     * Set the quality for video playback using the video quality object specific
     * for each player.
     * @type {Quality}
     */,
    set: function set(q) {
      this.internalPlayer.currentQuality = q;
    }

    /**
     * Get the manifest URL for the quality that is currently playing.
     * @type {string}
     */
  }, {
    key: "currentSrc",
    get: function get() {
      return this.internalPlayer.currentSrc;
    }

    /**
     * Get the current playlist item details.
     * @type {Playable}
     */
  }, {
    key: "currentPlaylistItem",
    get: function get() {
      return this.internalPlayer.currentPlaylistItem;
    }

    /**
     * Get the index of the currently playing item from the playlist.
     * @type {number}
     */
  }, {
    key: "currentPlaylistIndex",
    get: function get() {
      return this.internalPlayer.currentPlaylistIndex;
    }

    /**
     * Sets the current playlist index.
     * @type {number}
     */,
    set: function set(index) {
      this.internalPlayer.currentPlaylistIndex = index;
    }

    /**
     * Get the current playback position in the video (in seconds).
     * @type {number}
     */
  }, {
    key: "currentTime",
    get: function get() {
      return this.internalPlayer.src ? this.internalPlayer.currentTime : 0;
    }

    /**
     * Set the current playback position in the video (in seconds).
     * @type {number}
     */,
    set: function set(t) {
      this.internalPlayer.currentTime = t;
    }

    /**
     * Get the length of the currently loaded video (in seconds), if available.
     * @type {number}
     */
  }, {
    key: "duration",
    get: function get() {
      return this.internalPlayer.duration;
    }

    /**
     * Returns whether the video playback has ended or not.
     * @type {boolean}
     */
  }, {
    key: "ended",
    get: function get() {
      return this.internalPlayer.ended;
    }

    /**
     * Returns an object representing the error state of the video.
     * @type {object}
     */
  }, {
    key: "error",
    get: function get() {
      return this.internalPlayer.error;
    }

    /**
     * Returns whether the video player has frame accurate seeking enabled.
     * @type {boolean}
     */
  }, {
    key: "frameAccurateSeekEnabled",
    get: function get() {
      return this.internalPlayer.frameAccurateSeekEnabled;
    }

    /**
     * Set the whether the player should enable frame accurate seeking.
     * @type {boolean}
     */,
    set: function set(f) {
      this.internalPlayer.frameAccurateSeekEnabled = f;
    }
  }, {
    key: "hardQualitySwitchingEnabled",
    get: function get() {
      return this.internalPlayer.hardQualitySwitchingEnabled;
    },
    set: function set(val) {
      this.internalPlayer.hardQualitySwitchingEnabled = val;
    }

    /**
     * Returns whether the video player was initialized or not.
     * @type {boolean}
     */
  }, {
    key: "initialized",
    get: function get() {
      return this.internalPlayer.initialized;
    }

    /**
     * Returns whether the video playback was paused or not.
     * @type {boolean}
     */
  }, {
    key: "paused",
    get: function get() {
      return this.internalPlayer.paused;
    }

    /**
     * Returns whether the user is currently seeking in the video.
     * @type {boolean}
     */
  }, {
    key: "seeking",
    get: function get() {
      return this.internalPlayer.seeking;
    }

    /**
     * Returns the available qualities for the loaded video
     * @type {Quality[]}
     */
  }, {
    key: "qualities",
    get: function get() {
      return this.internalPlayer.qualities;
    }

    /**
     * Returns whether the audio output of the video is muted or not.
     * @type {boolean}
     */
  }, {
    key: "muted",
    get: function get() {
      return this.internalPlayer.muted;
    }

    /**
     * Sets the state of the audio output to muted or not.
     * @type {boolean}
     */,
    set: function set(m) {
      this.internalPlayer.muted = m;
    }

    /**
     * Returns the current source of the video player.
     * @type {string}
     */
  }, {
    key: "src",
    get: function get() {
      return this.internalPlayer.src;
    }

    /**
     * Sets the current source for the video player.
     * @type {string}
     */,
    set: function set(s) {
      this.playables = [{
        src: s
      }];
    }

    /**
     * Returns the volume level of the audio output in the [0, 1] range.
     * @type {number}
     */
  }, {
    key: "volume",
    get: function get() {
      return this.internalPlayer.volume;
    }

    /**
     * Sets the volume level of the audio output for the video.
     * @type {number}
     */,
    set: function set(v) {
      this.internalPlayer.volume = v;
    }

    /**
     * Gets the playback rate of the video player.
     * @type {number}
     */
  }, {
    key: "playbackRate",
    get: function get() {
      return this.internalPlayer.playbackRate;
    }

    /**
     * Sets the playback rate for the video player (e.g. `0.5`, `2.0`, `4.0`).
     * Note, normal playback rate has the value of `1.0`.
     * @type {number}
     */,
    set: function set(rate) {
      this.internalPlayer.playbackRate = rate;
    }

    /**
     * Gets the widht of the video player.
     * @type {number}
     */
  }, {
    key: "width",
    get: function get() {
      return this.internalPlayer.width;
    }

    /**
     * Sets the width for the video player.
     * @type {number}
     */,
    set: function set(w) {
      this.internalPlayer.width = w;
    }

    /**
     * Gets the height of the video player.
     * @type {number}
     */
  }, {
    key: "height",
    get: function get() {
      return this.internalPlayer.height;
    }

    /**
     * Sets the height for the video player.
     * @type {number}
     */,
    set: function set(h) {
      this.internalPlayer.height = h;
    }

    /**
     * Gets the name of the player that is used as an underlying technology.
     * Possible values: `theo`, `jw`.
     * @type {PlayerType}
     */
  }, {
    key: "playerType",
    get: function get() {
      return this.internalPlayer.name.toLowerCase();
    }

    /**
     * Gets the version of the player that is used as an underlying technology.
     * @type {string}
     */
  }, {
    key: "playerVersion",
    get: function get() {
      return this.internalPlayer.version;
    }

    /**
     * Returns true if the stream is live,  false otherwise.
     * @type {boolean}
     */
  }, {
    key: "live",
    get: function get() {
      return this.internalPlayer.live;
    }

    /**
     * Relevant to live streams,  returns the anticipated final duration of the
     * stream after encoding has finished.  Will never be greater than `duration`.
     * On VOD streams,  it will always be equal to `duration`.
     * @type {number}
     */
  }, {
    key: "expectedDuration",
    get: function get() {
      return this.internalPlayer.expectedDuration;
    }

    /**
     * Retrieve the current playingIndex of the playables
     * @type {number}
     */
  }, {
    key: "playingIndex",
    get: function get() {
      return this.internalPlayer.playingIndex;
    }

    /**
     * Sets the playingIndex and updates the video's source
     * @type {number}
     */,
    set: function set(index) {
      this.internalPlayer.playingIndex = index;
    }

    /**
     * Retrieve the playables this video has access to
     * @type {Array<Playables>}
     */
  }, {
    key: "playables",
    get: function get() {
      return this.internalPlayer.playables;
    },
    set: function set(playables) {
      var logger = this.internalPlayer.logger;
      if (logger.times.LoadTimeVideo === 0) {
        logger.times.LoadTimeInit = 0;
        logger.times.LoadTimeVideo = performance.now();
      }
      if (playables[0] && !playables[0].isDynamic) {
        this.updateCdnInformation(playables[0].src);
      }
      this.internalPlayer.playables = playables;
    }

    /**
     * Removes the player from the DOM and cleans up all resources.
     */
  }, {
    key: "destroy",
    value: function destroy() {
      this.internalPlayer.destroy();
    }

    /**
     * Sets the state to hide the spinner when performing some events such as scrubbing, or rewinding
     * @type {boolean}
     * @param {boolean} hide
     */
  }, {
    key: "hideSpinner",
    set: function set(hide) {
      this.internalPlayer.hideSpinner = hide;
    }
  }], [{
    key: "version",
    get: function get() {
      return packageVersion;
    }
  }]);
}();